<template>
  <b-container>
    <b-row>
      <b-col>
        <b-card no-body>
          <b-tabs pills card vertical v-model="currentTabIndex">
            <b-tab :title="$t('admin.settings.tabJobs')" active>
              <tab-Jobs></tab-Jobs>
            </b-tab>
            <b-tab :title="$t('admin.settings.tabRolesManagement')">
              <tab-Roles-Management></tab-Roles-Management>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import TabJobs from "@/components/AdminSettings/TabJobs";
import TabRolesManagement from "@/components/AdminSettings/TabRolesManagement";

export default {
  name: 'admin-settings',
  components: {TabRolesManagement, TabJobs},
  data() {
    return {
        currentTabIndex: 0
    }
  },
  mounted() {
    this.currentTabIndex = 0;
  },

}
</script>

<style scoped>


</style>